<template>
  <div class="navigation-companies-fi">
    <ul class="navigation-companies-fi__list">
      <li
        v-for="item in companies"
        :key="item.id"
        class="navigation-companies-fi__list-item"
      >
        <a
          :href="item.url"
          :target="item.target || undefined"
          :rel="item.target === '_blank' ? 'noopener noreferrer' : undefined"
          :data-test-2="item.label"
          data-test="company"
          class="navigation-companies-fi__list-item--link"
        >
          <cloud-image-fi
            v-if="item.teaserImage"
            :src="item.teaserImage.src"
            :alt="item.label"
            class="navigation-companies-fi__list-item__image"
          />

          <div
            class="navigation-companies-fi__list-item__label fi-text-18 fi-semibold lg:fi-text-21"
          >
            <span class="fi-mr-9">
              {{ item.label }}
            </span>
            <arrow-icon class="navigation-companies-fi__arrow" />
          </div>
        </a>
      </li>
    </ul>
  </div>
</template>

<script setup lang="ts">
import { ArrowIcon, CloudImageFi } from 'atoms';
import { computed } from 'vue';

import type { SitecoreNavigation } from '@/sitecoreState';
import { useNavigationStore } from '@/store/pinia/navigation';

defineOptions({ name: 'NavigationCompaniesFi' });

const navigationStore = useNavigationStore();

const subElements = computed<SitecoreNavigation[]>(() => navigationStore.subElements);

const companies = computed(() => subElements.value.filter((element) => element.isProxy));
</script>

<style scoped src="./navigation-companies-fi" />
